import React, { useEffect, useState } from 'react';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
} from 'firebase/firestore';
import { db } from './firebase';
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Stack,
  Box,
} from '@mui/material';

const FlavorManager = () => {
  const [flavors, setFlavors] = useState([]);
  const [newFlavor, setNewFlavor] = useState({ name: '', alias: '', tags: '' });
  const [editingId, setEditingId] = useState(null);

  const fetchFlavors = async () => {
    const snapshot = await getDocs(collection(db, 'recipe_flavors'));
    setFlavors(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    fetchFlavors();
  }, []);

  const handleSave = async () => {
    const data = {
      ...newFlavor,
      tags: newFlavor.tags.split(',').map(t => t.trim()).filter(Boolean),
    };

    if (editingId) {
      await updateDoc(doc(db, 'recipe_flavors', editingId), data);
    } else {
      await addDoc(collection(db, 'recipe_flavors'), data);
    }

    setNewFlavor({ name: '', alias: '', tags: '' });
    setEditingId(null);
    fetchFlavors();
  };

  const handleEdit = (flavor) => {
    setNewFlavor({
      name: flavor.name,
      alias: flavor.alias || '',
      tags: (flavor.tags || []).join(', '),
    });
    setEditingId(flavor.id);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'recipe_flavors', id));
    fetchFlavors();
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>🍓 Flavor Manager</Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Stack spacing={2}>
          <TextField
            label="Name"
            value={newFlavor.name}
            onChange={(e) => setNewFlavor({ ...newFlavor, name: e.target.value })}
            fullWidth
          />
          <TextField
            label="Alias"
            value={newFlavor.alias}
            onChange={(e) => setNewFlavor({ ...newFlavor, alias: e.target.value })}
            fullWidth
          />
          <TextField
            label="Tags (comma-separated)"
            value={newFlavor.tags}
            onChange={(e) => setNewFlavor({ ...newFlavor, tags: e.target.value })}
            fullWidth
          />
          <Button variant="contained" onClick={handleSave}>
            {editingId ? 'Update Flavor' : 'Add Flavor'}
          </Button>
        </Stack>
      </Paper>

      <Typography variant="h5" gutterBottom>🍹 Existing Flavors</Typography>
      <Stack spacing={2}>
        {flavors.map((flavor) => (
          <Paper key={flavor.id} sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6">{flavor.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Alias: {flavor.alias || '-'}<br />
                  Tags: {(flavor.tags || []).join(', ')}
                </Typography>
              </Box>
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" size="small" onClick={() => handleEdit(flavor)}>Edit</Button>
                <Button variant="outlined" size="small" color="error" onClick={() => handleDelete(flavor.id)}>Delete</Button>
              </Stack>
            </Box>
          </Paper>
        ))}
      </Stack>
    </Container>
  );
};

export default FlavorManager;
